module.exports = __webpack_public_path__ + "static/media/rest_sound.4ce2c65c.ogg";